import React, { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Home, Loader2 } from 'lucide-react';

const AuthCallback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { googleAuth } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Get session_id from URL fragment
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      const sessionId = sessionIdMatch ? sessionIdMatch[1] : null;
      const role = searchParams.get('role') || 'renter';

      if (!sessionId) {
        console.error('No session_id in URL');
        navigate('/login');
        return;
      }

      try {
        const user = await googleAuth(sessionId, role);
        navigate('/dashboard', { state: { user } });
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/login');
      }
    };

    processAuth();
  }, [googleAuth, navigate, searchParams]);

  return (
    <div className="min-h-screen bg-soft-gray flex items-center justify-center">
      <div className="text-center">
        <div className="inline-flex items-center gap-2 mb-6">
          <div className="w-10 h-10 bg-trust-blue rounded-lg flex items-center justify-center">
            <Home className="w-6 h-6 text-white" />
          </div>
          <span className="font-heading font-bold text-2xl text-slate-900">Stay Pair Homes</span>
        </div>
        <div className="flex items-center gap-3 text-slate-600">
          <Loader2 className="w-5 h-5 animate-spin" />
          <span>Signing you in...</span>
        </div>
      </div>
    </div>
  );
};

export default AuthCallback;
